var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chatWithPatientAvailable)?_c('chat-button-dropdown'):_c('b-nav-item',{staticClass:"mr-25",attrs:{"title":"Чат"}},[_c('feather-icon',{attrs:{"icon":"MessageSquareIcon","size":"21"},on:{"click":function($event){return _vm.openChat(_vm.appConstants.chat.type.COLLEAGUES)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }